import { Flex } from '@banhala/ui-kit';
import { useWebBaseURL, useWebViewActionFromMessage } from 'shared/src/hooks';
import { isNil, withWebviewOrigin } from 'shared/src/utils';
import { useMemo } from 'react';
import { WebView } from 'shared/src/component/WebWebView';
import { EMBEDDED_WEB_QUERY_KEY } from 'shared/src/constants/webviewQuery';

export const LikeWebView = ({ url }: { url?: string }) => {
  const webBaseUrl = useWebBaseURL();
  const webViewAction = useWebViewActionFromMessage();

  const resolvedUrl = useMemo(() => {
    if (isNil(url) || isNil(webBaseUrl)) return undefined;
    const parsed = new URL(url, webBaseUrl);
    parsed.searchParams.set('global_layout', 'app');
    // iframe 임베드임을 콘텐츠에 명시한다(.web 전용 구현이라 항상 임베드).
    parsed.searchParams.set(EMBEDDED_WEB_QUERY_KEY, 'true');
    // 내부 이동을 top 페이지로 승격하는 마커 (콘텐츠 useRouter가 처리, 앱바 중복 회피)
    parsed.searchParams.set('nav_target', 'top');

    // url 이 절대 URL 이면 위 `new URL(url, webBaseUrl)` 의 base 가 무시되므로
    // origin 을 여기서 한 번 더 맞춘다(스테이징에서 prod 콘텐츠로 새는 것 방지).
    return withWebviewOrigin(parsed);
  }, [url, webBaseUrl]);

  if (isNil(resolvedUrl)) return null;

  return (
    <Flex flex={1}>
      <WebView
        style={{ flex: 1 }}
        source={{ uri: resolvedUrl }}
        onMessage={webViewAction}
      />
    </Flex>
  );
};
